import { format, formatISO } from "date-fns";

import {
  EventAggregateParams,
  EventsParams,
  PointsHistoryParams,
  PointsHistoryQueryParams,
} from "./types";

export const eventsKeys = {
  list: (params?: EventsParams) => (params ? ["events", params] : ["events"]),
  aggregate: (params?: EventAggregateParams) =>
    params ? ["events", "aggregate", params] : ["events", "aggregate"],
  pointsHistory: (params?: PointsHistoryParams) =>
    params
      ? ["events", "points_history", params]
      : ["events", "points_history"],
};

/**
 * Format a Date object to the date string format useEvents accepts
 * @param date The date to format
 * @returns
 */
export const formatEventsDateFilter = (date: Date): string =>
  date.toDateString();

/**
 * Build query parameters for Points History with optional params if present.
 * @param params time parameters for query
 * @returns query parameters minus unset optional parameters
 */
export const buildPointsHistoryParams = (params?: PointsHistoryParams) => {
  const queryParams: PointsHistoryQueryParams = {
    timezone: params?.timezone ?? format(new Date(), "xxx"),
  };

  if (params?.endDate) {
    queryParams["end_date"] = formatISO(new Date(params.endDate));
  }

  if (params?.period) {
    queryParams["period"] = params.period;
  }

  return queryParams;
};
